import {
  EPolicyFields,
  EPolicySeverity,
  IArgs,
  TValue,
} from '../../types/policies-types';
import PoliciesStore, { IUpdatedPoliciesMap } from '../../store/policies';
import { snapshot } from 'valtio';

type TPolicyFieldValue = EPolicySeverity | boolean;

interface IUpdateProfilePolicyProps {
  id: string;
  field:
    | EPolicyFields.selected
    | EPolicyFields.severity
    | EPolicyFields.displayIssueSeverity;
  value: TPolicyFieldValue;
}

export const mergePoliciesChanges = (dirtyPolicies: IUpdatedPoliciesMap) => {
  for (const id in dirtyPolicies) {
    const updatePolicy = dirtyPolicies[id];
    const policyToUpate = PoliciesStore.policies[id];
    PoliciesStore.policies[id] = {
      ...policyToUpate,
      ...updatePolicy,
    };
  }
};

export function updateProfilePolicyProps({
  id,
  field,
  value,
}: IUpdateProfilePolicyProps) {
  const policyStore = snapshot(PoliciesStore);
  const targetPolicy = policyStore.policies[id];
  const { policyId } = targetPolicy;

  if (!PoliciesStore.dirtyPolicies) {
    PoliciesStore.dirtyPolicies = {};
  }

  PoliciesStore.dirtyPolicies[id] = {
    id,
    policyId,
    ...PoliciesStore.dirtyPolicies[id],
    [field]: value,
  };
}

export interface IUpdateProfilePolicyArgs {
  id: string;
  name: string;
  value: TValue;
}

export function updateProfilePolicyArgs({
  id,
  name,
  value,
}: IUpdateProfilePolicyArgs) {
  const policyStore = snapshot(PoliciesStore);
  const targetPolicy = policyStore.policies[id];
  const { policyId } = targetPolicy;
  if (!PoliciesStore.dirtyPolicies) {
    PoliciesStore.dirtyPolicies = {};
  }

  let dirtyPolicy = PoliciesStore.dirtyPolicies[id];

  if (!dirtyPolicy || !dirtyPolicy.args) {
    const coreArgs = targetPolicy.args.map(arg => {
      return { ...arg };
    });
    dirtyPolicy = {
      id,
      policyId,
      ...dirtyPolicy,
      args: coreArgs,
    };
  }
  const updatedArgs =
    dirtyPolicy.args &&
    dirtyPolicy.args.map(arg => {
      const { __typename, ...rest } = arg;
      return arg.name === name
        ? {
            ...rest,
            value,
            isDirty: true,
          }
        : { ...rest };
    });

  PoliciesStore.dirtyPolicies[id] = {
    ...dirtyPolicy,
    args: updatedArgs,
  };
}

export function prepareProfileInput(dirtyPolicies: IUpdatedPoliciesMap) {
  return Object.values(dirtyPolicies).map(p => {
    const dirtyArgs: Partial<IArgs>[] = (p.args || [])
      .filter(arg => arg.isDirty)
      .map(arg => {
        const { id, value } = arg;
        return {
          id,
          value,
        };
      });
    return {
      ...p,
      args: dirtyArgs,
    };
  });
}

export function cancelProfilePoliciesChanges() {
  PoliciesStore.dirtyPolicies = undefined;
}
